import {Component, Output, Input, EventEmitter} from '@angular/core';
import {StudiosService} from './../../services/studios';
import {MapService} from './../../services/map'
import {SessionService} from '../../services/session';

declare var google: any;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
})
export class MapComponent {
  @Output() studioSelected = new EventEmitter();
  @Input() selectStudio: any;

  constructor(
    public studiosService: StudiosService,
    public mapService: MapService,
    public sessionService: SessionService
  ) {
  }

  map: any;
  lastSelectedMarker = null;
  myMarker: any;

  factor = 0.25;
  selected = {
    url: './assets/img/map/selected.png', // url
    scaledSize: new google.maps.Size(89 * this.factor * 1.05, 100 * this.factor * 1.05), // scaled size
  };

  nonSelected = {
    url: './assets/img/map/non_selected.png', // url
    scaledSize: new google.maps.Size(89 * this.factor, 100 * this.factor), // scaled size
  };

  nonSelectedPro = {
    url: this.sessionService.user.pro ?
      './assets/img/map/non_selected.png' : './assets/img/map/non_selected_pro.png', // url
    scaledSize: new google.maps.Size(89 * this.factor, 100 * this.factor), // scaled size
  };

  myLocation = {
    url: './assets/img/map/my_location.png'
  }

  ngOnInit() {
    this.initMap(this.mapService.myLocation);
    this.addMarkers();
    if (!this.lastSelectedMarker && !this.mapService.lastSelectedMarker) {
      this.addMyLocation();
    }
  }

  //Makes a google map
  initMap(center) {
    this.map = new google.maps.Map(document.getElementById('map'), {
      center: center,
      zoom: 14,
      disableDefaultUI: true
    });
    this.map.addListener('click', () => {
      this.removeLastSelectedMarker()
      this.studioSelected.emit({studioInfo: null})
    });
  }

  //adds all found markers
  addMarkers() {
    this.studiosService.studios.forEach((studioInfo: any) => {
      if (
        this.mapService.lastSelectedMarker && studioInfo.id ===
        this.mapService.lastSelectedMarker.id
      ) {
        this.addMarkersWithPreviouslySelectedMarker(studioInfo)
      } else {
        var marker = new google.maps.Marker({
          position: {
            lat: Number(studioInfo.latitude),
            lng: Number(studioInfo.longitude)
          },
          map: this.map,
          info: studioInfo,
          icon: studioInfo.pro ? this.nonSelectedPro : this.nonSelected
        })
        marker.addListener('click', () => {
          this.removeLastSelectedMarker()
          marker.setIcon(this.selected)
          this.lastSelectedMarker = marker;
          this.mapService.lastSelectedMarker = studioInfo;
          this.emitToFatherComponent(studioInfo)
        });
      }
    })
    if (this.selectStudio) {
      this.selectAMarker(this.selectStudio)
    }
  }

  addMarkersWithPreviouslySelectedMarker(studioInfo) {
    var marker = new google.maps.Marker({
      position: {
        lat: Number(studioInfo.latitude),
        lng: Number(studioInfo.longitude)
      },
      map: this.map,
      info: studioInfo,
      icon: this.selected
    })
    marker.addListener('click', () => {
      this.removeLastSelectedMarker()
      marker.setIcon(this.selected)
      this.lastSelectedMarker = marker;
      this.mapService.lastSelectedMarker = studioInfo;
      this.emitToFatherComponent(studioInfo)
    });
    this.map.panTo({
      lat: Number(studioInfo.latitude),
      lng: Number(studioInfo.longitude)
    })
    this.lastSelectedMarker = marker;
    this.emitToFatherComponent(studioInfo)
  }

  //ads a marker in my current position and pans to it
  addMyLocation() {
    if (this.myMarker) {
      this.myMarker.setMap(this.map)
    }
    this.myMarker = new google.maps.Marker({
      position: this.mapService.myLocation,
      map: this.map,
      icon: this.myLocation
    });
    this.map.panTo(this.mapService.myLocation)
  }

  //listens if there is an input in the search bar
  ngOnChanges() {
    if (this.map) {
      if (this.selectStudio) {
        this.selectAMarker(this.selectStudio)
      } else {
        this.removeLastSelectedMarker()
      }
    }
  }

  //Adds a new Marker in studioInfo
  selectAMarker(studioInfo) {
    this.mapService.lastSelectedMarker = studioInfo;
    var marker = new google.maps.Marker({
      position: {
        lat: Number(studioInfo.latitude),
        lng: Number(studioInfo.longitude)
      },
      map: this.map,
      info: studioInfo,
      icon: this.selected,
      zIndex: 1 + this.studiosService.studios.length,
    })
    this.map.panTo({
      lat: Number(studioInfo.latitude),
      lng: Number(studioInfo.longitude)
    })
    marker.addListener('click', () => {
      this.removeLastSelectedMarker()
      marker.setIcon(this.selected)
      this.lastSelectedMarker = marker;
      this.mapService.lastSelectedMarker = studioInfo;
      this.emitToFatherComponent(studioInfo)
    });
    this.removeLastSelectedMarker()
    this.lastSelectedMarker = marker;
    this.emitToFatherComponent(studioInfo);

  }

  //removes the Last selected marker
  removeLastSelectedMarker() {
    if (this.lastSelectedMarker) {
      this.lastSelectedMarker.setIcon(this.lastSelectedMarker.info.pro ? this.nonSelectedPro : this.nonSelected)
    }
  }

  emitToFatherComponent(studioInfo) {
    setTimeout(() => {
      this.studioSelected.emit({studioInfo})
    }, 1);
  }

}



// WEBPACK FOOTER //
// ./src/components/map/map.component.ts